import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-cms-side-bar',
  templateUrl: './cms-side-bar.component.html',
  styleUrls: ['./cms-side-bar.component.scss']
})
export class CmsSideBarComponent implements OnInit {

  @Input() active
  @Input() show = "y"
  role: any

  constructor() { }

  ngOnInit(): void {
  }

  click(status){
    if(status == 'n'){
      this.show = "n";
    }else{
      this.show = "y";
    }
  }

}
